import * as cheerio from "cheerio";
import admin from "firebase-admin";
const GITHUB_API_KEY = "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";
const getLatestTag = () => {
  const url = "https://api.github.com/repos/carlelieser/glimmr-release/tags";
  return fetch(url, {
    headers: {
      Authorization: `Bearer ${GITHUB_API_KEY}`
    }
  }).then((response) => response.json()).then((tags) => {
    const latest = tags[0];
    if (!latest)
      return null;
    return latest;
  }).catch(() => {
    return null;
  });
};
const getInstallerMetadata = async (tag) => {
  const response = await fetch(
    `https://github.com/carlelieser/glimmr-release/releases/expanded_assets/${tag}`
  );
  const html = await response.text();
  const $ = cheerio.load(html);
  const link = $(`a[href*='/carlelieser/glimmr-release/releases/download/${tag}/']`);
  const size = link.parent().parent().children().last().children().first().text().trim();
  return {
    url: `/releases/${tag}/glimmr-setup.exe`,
    name: "glimmr-setup.exe",
    tag,
    size
  };
};
const getUserCount = async (count = 0, pageToken = void 0) => {
  const result = await admin.auth().listUsers(1e3, pageToken);
  count += result.users.length;
  if (result.pageToken) {
    count = await getUserCount(count, result.pageToken);
  }
  return count;
};
const load = async () => {
  const tag = await getLatestTag();
  const metadata = await getInstallerMetadata(tag.name);
  const userCount = await getUserCount();
  return {
    metadata,
    userCount
  };
};
export {
  load
};
